"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaccinationManufacturer = void 0;
exports.instanceOfVaccinationManufacturer = instanceOfVaccinationManufacturer;
exports.VaccinationManufacturerFromJSON = VaccinationManufacturerFromJSON;
exports.VaccinationManufacturerFromJSONTyped = VaccinationManufacturerFromJSONTyped;
exports.VaccinationManufacturerToJSON = VaccinationManufacturerToJSON;
exports.VaccinationManufacturerToJSONTyped = VaccinationManufacturerToJSONTyped;
/**
 *
 * @export
 */
exports.VaccinationManufacturer = {
    PfizerBiotech: 'PFIZER_BIOTECH',
    Moderna: 'MODERNA',
    JohnsonAndJohnson: 'JOHNSON_AND_JOHNSON',
    Novavax: 'NOVAVAX',
    Other: 'OTHER'
};
function instanceOfVaccinationManufacturer(value) {
    for (const key in exports.VaccinationManufacturer) {
        if (Object.prototype.hasOwnProperty.call(exports.VaccinationManufacturer, key)) {
            if (exports.VaccinationManufacturer[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function VaccinationManufacturerFromJSON(json) {
    return VaccinationManufacturerFromJSONTyped(json, false);
}
function VaccinationManufacturerFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function VaccinationManufacturerToJSON(value) {
    return value;
}
function VaccinationManufacturerToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=VaccinationManufacturer.js.map